// Framework and third-party non-ui
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Redux operations and local helpers/utils/modules
import { incidentOperations } from '../../redux/incident';
import { getIncidentStatus } from '../../utils/incidentHelper';
import enums from '../../defaults/Enums.json';
import { history } from '../../index';

// App components
import ReportHeader from './ReportHeader';
import ReportInfoSection from './ReportInfoSection';
import ReportMapSection from './ReportMapSection';
import RelatedRecordsDialog from '../../components/incidentDetails/relatedRecords/RelatedRecordsDialog';

// Third-party components (buttons, icons, etc.)

// JSON

// CSS
import './Report.css';

class Report extends Component {

  constructor(props) {
    super(props);
    this.state =
    {
      certifierInfo: null,
      showingRelatedRecordsDialog: false
    };

    this.getCertifierFromIncident();
    this.getRelatedRecordIdentifiersFromIncident();
  }

  getRelatedRecordIdentifiersFromIncident = () => {
    if (this.props.selectedIncident.incident !== null) {

      window.api.getRelatedRecords(this.props.selectedIncident.incident.attributes.FORID).then(resp =>
        {
        this.setState({
          relatedRecords: resp
        });
      }); 
    }
  }

  getCertifierFromIncident = () => {
    if (this.props.selectedIncident.incident !== null) {
      let statusVal = getIncidentStatus(this.props.selectedIncident.incident);
      if (statusVal === enums.incidentStatus.certified) {
        const lastUpdateUser = this.props.selectedIncident.incident.attributes["INFORMUserName"];
        if (lastUpdateUser !== null) {
          window.api.getUserGroups(lastUpdateUser).then(response => {
            this.setState({
              certifierInfo: response
            });
          });
        }
      }
    }
  }

  showRelatedRecordsDialog = () => {
    this.setState({
      showingRelatedRecordsDialog: true
    });
  }

  hideRelatedRecords = () => {
    this.setState({
      showingRelatedRecordsDialog: false
    });
  }

  componentDidMount() {
    const routeIncidentId = this.props.match.params.incidentId || null;

    if (!this.props.selectedIncident || !this.props.selectedIncident.incident) {
      if (routeIncidentId) {
        history.push(`/incidents/${routeIncidentId}`)
      }
      else {
        history.push('/incidents')
      }
    }
  }


  render() {
    if (!this.props.selectedIncident || !this.props.selectedIncident.incident) {
      return (<div>No Incident Found</div>);
    }

    return (
      <div className="report-page">
        <ReportHeader selectedIncident={this.props.selectedIncident} />
        <ReportInfoSection
          selectedIncident={this.props.selectedIncident}
          fieldInfos={this.props.appConfig.fieldInfos}
          dateFormat={this.props.appConfig.timeDateFormat}
          relatedRecords={this.state.relatedRecords}
        />
        <ReportMapSection
          selectedIncident={this.props.selectedIncident}
          fieldInfos={this.props.appConfig.fieldInfos}
          dateFormat={this.props.appConfig.timeDateFormat}
          screenshot={this.props.screenshot}
          relatedRecords={this.state.relatedRecords}
          showRelatedRecords={this.showRelatedRecordsDialog}
          certifierInfo={this.state.certifierInfo} />
          <RelatedRecordsDialog
            open={this.state.showingRelatedRecordsDialog}
            relatedRecords={this.state.relatedRecords}
            onRequestClose={this.hideRelatedRecords} />
      </div>
    );
  }
}

Report.propTypes = {};

Report.defaultProps = {};

const mapStateToProps = state => ({
  appConfig: state.config,
  selectedIncident: state.incident,
  screenshot: state.report.screenshot,
  certifierInfo: state.certifierInfo
})

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    ...incidentOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Report)
